import { render, staticRenderFns } from "./TablaSeveridad.vue?vue&type=template&id=4bc28d90&scoped=true&"
import script from "./TablaSeveridad.vue?vue&type=script&lang=js&"
export * from "./TablaSeveridad.vue?vue&type=script&lang=js&"
import style0 from "./TablaSeveridad.vue?vue&type=style&index=0&id=4bc28d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc28d90",
  null
  
)

component.options.__file = "TablaSeveridad.vue"
export default component.exports